import { useAuth } from '../contexts/AuthContext';
import { useProducts } from '../hooks/useProducts';
import { useWishlists } from '../hooks/useWishlists';
import { useBudget } from '../hooks/useBudget';
import CatalogSearch from '../components/CatalogSearch';
import AddProductForm from '../components/AddProductForm';
import WishlistList from '../components/WishlistList';
import BudgetSettings from '../components/BudgetSettings';

export default function Dashboard() {
  const { user } = useAuth();
  const { data: products } = useProducts();
  const { data: wishlists } = useWishlists();
  const { data: budget } = useBudget();

  const productCount = products?.length ?? 0;
  const wishlistCount = wishlists?.length ?? 0;

  const budgetDisplay = budget?.monthly_limit
    ? `$${(budget.current_month_spent ?? 0).toFixed(0)} / $${budget.monthly_limit.toFixed(0)}`
    : '–';

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-foreground">
          Welcome to AWL
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {user?.email
            ? `Signed in as ${user.email}`
            : 'Your AI shopping agent dashboard'}
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <div className="rounded-lg border border-border bg-card p-6">
          <h3 className="text-sm font-medium text-muted-foreground">
            Tracked Products
          </h3>
          <p className="mt-2 text-3xl font-semibold text-card-foreground">
            {productCount}
          </p>
        </div>
        <div className="rounded-lg border border-border bg-card p-6">
          <h3 className="text-sm font-medium text-muted-foreground">
            Wishlists
          </h3>
          <p className="mt-2 text-3xl font-semibold text-card-foreground">
            {wishlistCount}
          </p>
        </div>
        <div className="rounded-lg border border-border bg-card p-6">
          <h3 className="text-sm font-medium text-muted-foreground">
            Monthly Budget
          </h3>
          {budget?.monthly_limit ? (
            <p className="mt-2 text-3xl font-semibold text-card-foreground">
              {budgetDisplay}
            </p>
          ) : (
            <a
              href="#budget-settings"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('budget-settings')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-2 inline-block text-lg font-medium text-primary hover:underline"
            >
              Set up &rarr;
            </a>
          )}
        </div>
      </div>

      <CatalogSearch />

      <AddProductForm />

      <WishlistList />

      <BudgetSettings />
    </div>
  );
}
